import React, { Component } from 'react';
import Select from 'react-select';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

class RowRenderer extends Component {
    render() {
        return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} ><ReactDataGrid.Row ref='row' {...this.props} /></div>);
    }
}

export class DisplayCategoryModal extends Component {
    constructor() {
        super();
        this.state = {
            groupOptionsDisplay: <Translate value="all" />,
            currentGroup: 'all',
            currentNotIncludedCategories: {
                rows: [],
                filters: {},
                selectedRows: null,
                sortColumn: null,
                sortDirection: null
            },
            currentIncludedCategories: {
                rows: [],
                filters: {},
                selectedRows: null,
                sortColumn: null,
                sortDirection: null
            },
            filterNotIncluded: {
                rows: [],
                filters: {},
                selectedRows: null,
                sortColumn: null,
                sortDirection: null
            },
            filterIncluded: {
                rows: [],
                filters: {},
                selectedRows: null,
                sortColumn: null,
                sortDirection: null
            },
            productId: null,
            outputCategories: null,
        };
        this.moveNotIncluded = this.moveNotIncluded.bind(this);
        this.moveIncluded = this.moveIncluded.bind(this);
        this.handleSaveClicked = this.handleSaveClicked.bind(this);
    }

    componentDidMount() {
        this.props.getDisplayCategories(this.props.productId);
        this.setState({
            productId: this.props.productId,
        });
    }

    componentWillReceiveProps(nextProps) {
        let currentNotIncludedCategories = { rows: [] };
        let currentIncludedCategories = { rows: [] };
        let formatArray = null;
        if (nextProps.displayCategories) {
            nextProps.displayCategories.map(displayCategories => {
                formatArray = Object.values(displayCategories.Categories);
                formatArray.map(Categories => {
                    if (Categories.IsSelected === true) {
                        currentIncludedCategories['rows'].push({ IsSelected: Categories.IsSelected, ProductCategoryDisplay_id: Categories.ProductCategoryDisplay_id, Name: Categories.Name, DisplayName: Categories.Name + ' (' + displayCategories.Name + ')', GroupId: displayCategories.ProductGroup_id, GroupName: displayCategories.Name });
                    } else {
                        currentNotIncludedCategories['rows'].push({ IsSelected: Categories.IsSelected, ProductCategoryDisplay_id: Categories.ProductCategoryDisplay_id, Name: Categories.Name, DisplayName: Categories.Name + ' (' + displayCategories.Name + ')', GroupId: displayCategories.ProductGroup_id, GroupName: displayCategories.Name });
                    }
                });
            });
            this.setState({
                currentNotIncludedCategories: currentNotIncludedCategories,
                currentIncludedCategories: currentIncludedCategories,
                outputCategories: nextProps.displayCategories,
            });
        }
    }

    componentDidUpdate() {
    }

    handleGroupChange = (el) => {
        this.setState({
            groupOptionsDisplay: el.label,
            currentGroup: el.value,
        });
    }

    getGroupOptions() {
        const groupOptions = [];
        this.props.displayCategories.map(displayCategories => {
            groupOptions.push({ value: displayCategories.ProductGroup_id, label: displayCategories.Name })
        });
        groupOptions.push({ value: 'all', label: <Translate value="all" /> })
        return groupOptions;
    }

    renderGroupFilter() {
        const groupOptions = this.getGroupOptions();
        return (
            <div style={{ marginLeft: '10px', marginBottom: '15px' }}>
                <Row>
                    <Col>
                        <label style={{ width: '150px', fontSize: '14px' }}><Translate value="group_list" />:</label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Dropdown>
                            <Dropdown.Toggle style={{ width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                {this.state.groupOptionsDisplay}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                                {groupOptions.map(el => {
                                    return (
                                        <MenuItem onClick={() => this.handleGroupChange(el)}>{el.label}</MenuItem>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>
            </div>
        );
    }

    moveNotIncluded(category) {
        let leftRows = [...this.state.currentNotIncludedCategories.rows];
        let rightRows = [...this.state.currentIncludedCategories.rows];
        let index = _.findIndex(leftRows, { ProductCategoryDisplay_id: category.ProductCategoryDisplay_id });
        if (index > -1) {
            leftRows.splice(index, 1);
            rightRows.push(category);
        }
        let leftCategories = { ...this.state.currentNotIncludedCategories, rows: leftRows }
        // .sort((a,b) => {return a.name.localeCompare(b.name)})
        let rightCategories = { ...this.state.currentIncludedCategories, rows: rightRows }
        this.setState({ currentNotIncludedCategories: leftCategories, currentIncludedCategories: rightCategories });
    }

    moveIncluded(category) {
        let leftRows = [...this.state.currentNotIncludedCategories.rows];
        let rightRows = [...this.state.currentIncludedCategories.rows];
        let index = _.findIndex(rightRows, { ProductCategoryDisplay_id: category.ProductCategoryDisplay_id });
        if (index > -1) {
            rightRows.splice(index, 1);
            leftRows.push(category);
        }
        let leftCategories = { ...this.state.currentNotIncludedCategories, rows: leftRows }
        let rightCategories = { ...this.state.currentIncludedCategories, rows: rightRows }
        this.setState({ currentNotIncludedCategories: leftCategories, currentIncludedCategories: rightCategories });
    }

    handleSaveClicked() {
        let outputFormatArray = null;
        this.state.outputCategories.map(groups => {
            outputFormatArray = Object.values(groups.Categories);
            outputFormatArray.map(categories => {
                this.state.currentIncludedCategories.rows.map(included => {
                    if (categories.ProductCategoryDisplay_id === included.ProductCategoryDisplay_id) {
                        categories.IsSelected = true;
                    }
                });
                this.state.currentNotIncludedCategories.rows.map(notIncluded => {
                    if (categories.ProductCategoryDisplay_id === notIncluded.ProductCategoryDisplay_id) {
                        categories.IsSelected = false;
                    }
                });
            });
        });
        this.props.editDisplayCategories(this.state.productId, this.state.outputCategories);
        this.props.closeModal();
    }

    renderNotIncluded() {
        this.state.filterNotIncluded = {
            rows: [],
            filters: {},
            selectedRows: null,
            sortColumn: null,
            sortDirection: null
        }
        if (this.state.currentGroup === 'all') {
            this.state.filterNotIncluded.rows = this.state.currentNotIncludedCategories.rows;
        } else {
            this.state.currentNotIncludedCategories.rows.map(row => {
                if (row.GroupId === this.state.currentGroup) {
                    this.state.filterNotIncluded.rows.push(row);
                }
            });
        }

        const getRows = () => {
            return Data.Selectors.getRows(this.state.filterNotIncluded);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleGridSort = (sortColumn, sortDirection) => {
            var filterNotIncluded = Object.assign({}, this.state.filterNotIncluded, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({ filterNotIncluded });
        }
        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filterNotIncluded.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const filterNotIncluded = { ...this.state.filterNotIncluded, filters: newFilters };
            this.setState({ filterNotIncluded });
        }
        const columns = [
            {
                key: 'DisplayName',
                name: <Translate value="category_hidden" />,
                resizable: true,
                width: 328,
                sortable: true,
                filterable: true,
            },
            // {
            //     key: 'GroupName',
            //     name: <Translate value="group" />,
            //     resizable: true,
            //     width: 100,
            //     sortable: true,
            //     filterable: true,
            // }
        ]

        return (
            <Col sm={6}><div style={{ maxWidth: '100%' }} id="DisplayCategoryModal-dataGrid1">
                {/* <label style={{ width: '150px', fontSize: '14px', position: 'absolute', paddingTop: '5px'}}><Translate value="category_hidden" />:</label> */}
                <ReactDataGrid
                    rowRenderer={<RowRenderer onDoubleClick={this.moveNotIncluded} />}
                    rowKey='ProductCategoryDisplay_id'
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter={true} />}
                    onAddFilter={handleFilterChange}
                    columns={columns}
                    rowHeight={25}
                    minHeight={285}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                />
            </div></Col>
        )
    }

    renderIncluded() {
        this.state.filterIncluded = {
            rows: [],
            filters: {},
            selectedRows: null,
            sortColumn: null,
            sortDirection: null
        }
        if (this.state.currentGroup === 'all') {
            this.state.filterIncluded.rows = this.state.currentIncludedCategories.rows;
        } else {
            this.state.currentIncludedCategories.rows.map(row => {
                if (row.GroupId === this.state.currentGroup) {
                    this.state.filterIncluded.rows.push(row);
                }
            });
        }

        const getRows = () => {
            return Data.Selectors.getRows(this.state.filterIncluded);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleGridSort = (sortColumn, sortDirection) => {
            var filterIncluded = Object.assign({}, this.state.filterIncluded, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({ filterIncluded });
        }
        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filterIncluded.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const filterIncluded = { ...this.state.filterIncluded, filters: newFilters };
            this.setState({ filterIncluded });
        }
        const columns = [
            {
                key: 'DisplayName',
                name: <Translate value="category_visible" />,
                resizable: true,
                width: 328,
                sortable: true,
                filterable: true
            }
        ]

        return (
            <Col sm={6}><div style={{ maxWidth: '100%' }} id="DisplayCategoryModal-dataGrid2">
                {/* <label style={{ width: '150px', fontSize: '14px', position: 'absolute', paddingTop: '5px'}}><Translate value="category_visible" />:</label> */}
                <ReactDataGrid
                    rowRenderer={<RowRenderer onDoubleClick={this.moveIncluded} />}
                    rowKey='ProductCategoryDisplay_id'
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter={true} />}
                    onAddFilter={handleFilterChange}
                    columns={columns}
                    rowHeight={25}
                    minHeight={285}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                />
            </div></Col>
        )
    }

    render() {
        return (
            <div>
                <Row >
                    <Col xs={12} style={{ position: 'absolute' }}>
                        <Button
                            bsStyle="success"
                            type="button"
                            style={{ marginTop: '21px', marginLeft: '165px' }}
                            onClick={this.handleSaveClicked}
                        >
                            <em className="fa fa-save" />
                            <Translate value="save" />
                        </Button>
                    </Col>
                </Row>
                {this.renderGroupFilter()}
                <Row>
                    {this.renderNotIncluded()}
                    {this.renderIncluded()}
                </Row>
            </div>
        );
    }
}

export default DisplayCategoryModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/displayCategoryModal.jsx